import { format } from "date-fns";

export const PROGRAM_DAYS = 6;
export const PROGRAM_START = new Date(2026, 9, 7);
export const DEMO_DAY = new Date(2026, 9, 13, 14, 0, 0);

const DAY_MS = 86_400_000;

function startOfDay(d: Date): number {
  return new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
}

export function dayDate(day: number): Date {
  const d = new Date(PROGRAM_START);
  d.setDate(d.getDate() + day - 1);
  return d;
}

/** < 1 before the program, 1–6 build days, 7 Demo Day, > 7 after. */
export function currentProgramDay(now = new Date()): number {
  return Math.floor((startOfDay(now) - startOfDay(PROGRAM_START)) / DAY_MS) + 1;
}

export function demoCountdown(now = new Date()) {
  const ms = Math.max(DEMO_DAY.getTime() - now.getTime(), 0);
  return {
    done: ms === 0,
    days: Math.floor(ms / DAY_MS),
    hours: Math.floor((ms % DAY_MS) / 3_600_000),
    minutes: Math.floor((ms % 3_600_000) / 60_000),
  };
}

export function formatDay(day: number, pattern = "EEE, MMM d"): string {
  return format(dayDate(day), pattern);
}

export function formatBytes(bytes: number): string {
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
